import {createSlice} from "@reduxjs/toolkit";
import {ShopItemsListResponse} from "@/app/_api/types/store";
import {RootState} from "@/app/store";
import {getPaymentItemsAsync, openPaymentAsync} from "@/app/(pages)/paymentItemsAPI";

export interface ShopItemsState {
    shopItemsData: ShopItemsListResponse; //所有商品数据
    shopItemsRegularData: ShopItemsListResponse; //常规商品数据
    shopItemsSpecialData: ShopItemsListResponse; //特价商品数据
    shopItemsStarterData: ShopItemsListResponse; //新手礼包商品数据
    responseStatus: 'finish' | 'loading' | 'failed'
}

// 初始状态
const initialState: ShopItemsState = {
    shopItemsData: [],
    shopItemsRegularData: [],
    shopItemsSpecialData: [],
    shopItemsStarterData: [],
    responseStatus: 'loading',
}

export const ShopItemsSlice = createSlice({
    name: 'paymentItems',
    initialState,
    reducers: {
        updateShopItems: (state, action) => {
            state.shopItemsData = action.payload;
        }
    },
    extraReducers: builder => {
        // 获取商品配置回调
        builder
            .addCase(getPaymentItemsAsync.pending, (state) => {
                state.responseStatus = 'loading';
            })
           .addCase(getPaymentItemsAsync.fulfilled, (state, action) => {
                state.responseStatus = 'finish';
                state.shopItemsData = action.payload;
                state.shopItemsRegularData = action.payload.filter(item => item.itemsType === 1);
                state.shopItemsSpecialData = action.payload.filter(item => item.itemsType === 2);
                state.shopItemsStarterData = action.payload.filter(item => item.itemsType === 3);
            })
          .addCase(getPaymentItemsAsync.rejected, (state) => {
                state.responseStatus = 'failed';
            })
        // 获取XTG交易配置回调
        builder
            .addCase(openPaymentAsync
                .pending, (state) => {
                state.responseStatus = 'loading';
            })
            .addCase(openPaymentAsync.fulfilled,  (state, action) => {
                state.responseStatus = 'finish';
            })
            .addCase(openPaymentAsync.rejected, (state, action) => {
                state.responseStatus = 'failed';
            })
    }
})

export const { updateShopItems } = ShopItemsSlice.actions;

export const selectShopItems = (state: RootState) => state.shopItems;

export default ShopItemsSlice.reducer;